import { Dispatch } from 'redux';

import { TagPayload } from '@/features/PCP/containers/FilterTagsContainer';
import { setPageNumber } from '@/store/redux/actions/pages/pcp';
import { DriveStateProps } from '@/store/redux/reducers/pages/pcp/filters/drive';

import { IReduxActionProps } from './../../../../../Utils/index';

export const SET_FILTER_DRIVE = 'SET_FILTER_DRIVE';
export const DELETE_FILTER_DRIVE = 'DELETE_FILTER_DRIVE';
export const RESET_FILTER_DRIVE = 'RESET_FILTER_DRIVE';

export const setDriveFilters = ({
  gearBox,
  power,
  maxCubicCapacity,
}: DriveStateProps) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: SET_FILTER_DRIVE,
      payload: {
        gearBox,
        power,
        maxCubicCapacity,
      },
    });
  };
};

export const deleteFilterDrive = (payload: TagPayload) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: DELETE_FILTER_DRIVE,
      payload,
    });
  };
};

export const resetFilterDrve = (): IReduxActionProps => {
  return {
    type: RESET_FILTER_DRIVE,
  };
};
